export function camelCase(input) {
  if (typeof input !== 'string') return '';
  return input.charAt(0).toLocaleLowerCase() + input.slice(1);
}
